<template>
  <Badge :variant="COUNTERPARTY_TYPE_VARIANT[counterpartyType]" :size="size">
    {{ t(`counterpartyTypes.${counterpartyType}`) }}
  </Badge>
</template>

<script setup lang="ts">
import Badge from '@/components/Badge.vue';
import type { BadgeVariant } from '@carvia/theme/lib/cva/badge';
import { CounterpartyType } from '@/entities/ledger/ledger-entry.entity';
import { useI18n } from 'vue-i18n';

defineProps<{
  counterpartyType: CounterpartyType;
  size?: 'sm' | 'md';
}>();

const { t } = useI18n();

const COUNTERPARTY_TYPE_VARIANT: Record<CounterpartyType, BadgeVariant> = {
  [CounterpartyType.CUSTOMER]: 'info',
  [CounterpartyType.AGENCY]: 'warning',
  [CounterpartyType.OTHER]: 'neutral',
};
</script>
